import { useEffect, useState }          from 'react';
import { useTranslation }               from 'react-i18next';
import { CheckCircleFilled }            from '@ant-design/icons';
import ReactCountryFlag                 from 'react-country-flag';
import { Typography, Dropdown, 
          Button, Tooltip }             from 'antd';

const { Text } = Typography;

function formatDate(date: Date, language: string): string {
  const locale =
    language === 'hu'
      ? 'hu-HU'
      : language === 'zhTW'
      ? 'zh-TW'
      : 'en-US';

  const timeZone =
    language === 'zhTW'
      ? 'Asia/Taipei'
      : undefined;

  return date.toLocaleString(locale, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    timeZone,
  });
};

export const HeaderActions = () => {
  const [currentTime, setCurrentTime] = useState(() => new Date());

  const { t, i18n } = useTranslation();

  const flagIcon =
    i18n.language === 'hu'
      ? 'HU'
      : i18n.language === 'zhTW'
      ? 'TW'
      : 'US';

  const changeLanguage = (lang: 'hu' | 'en' | 'zhTW') => {
    i18n.changeLanguage(lang)
    localStorage.setItem('lang', lang)
  };

  const languageMenu = {
    items: [
      {
        key: 'hu',
        label: (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
          }}
        >
          <span>{ t('headerLanguageDropdown.hun') }</span>
          <ReactCountryFlag
            countryCode="HU"
            svg
            style={{
              width: '20px',
              height: '20px',
            }}
          />
        </div>
      ),
        onClick: () => changeLanguage('hu'),
        icon: i18n.language === 'hu' ? <CheckCircleFilled /> : <CheckCircleFilled style={{ visibility: 'hidden' }} />
      },
      {
        key: 'en',
        label: (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
          }}
        >
          <span>{ t('headerLanguageDropdown.us') }</span>
          <ReactCountryFlag
            countryCode="US"
            svg
            style={{
              width: '20px',
              height: '20px',
            }}
          />
        </div>
      ),
        onClick: () => changeLanguage('en'),
        icon: i18n.language === 'en' 
          ? <CheckCircleFilled /> 
          : <CheckCircleFilled style={{ visibility: 'hidden' }} />
      },

      {
        key: 'zhTW',
        label: (
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <span>{t('headerLanguageDropdown.tw')}</span>
            <ReactCountryFlag countryCode="TW" svg style={{ width: 20, height: 20 }} />
          </div>
        ),
        onClick: () => changeLanguage('zhTW'),
        icon:
          i18n.language === 'zhTW'
            ? <CheckCircleFilled />
            : <CheckCircleFilled style={{ visibility: 'hidden' }} />,
      },
    ],
  };

  useEffect(() => {
    const interval = setInterval(() => setCurrentTime(new Date()), 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div
      style={{
        display: 'flex',
        gap: '12px',
        alignItems: 'center',
      }}
    >
      <Text>
        <time>{formatDate(currentTime, i18n.language)}</time>
      </Text>

      <Tooltip title={t('headerLanguageDropdown.tooltip')}>
        <Dropdown menu={languageMenu} trigger={['click']}>
          <Button
            type="text"
            icon={
              <ReactCountryFlag
                countryCode={flagIcon}
                svg
                style={{
                  width: '20px',
                  height: '20px',
                  verticalAlign: 'baseline'
                }}
              />
            }
          />
        </Dropdown>
      </Tooltip>
    </div>
  )
}